import { WindowsIconUrl } from "@p0security/shared/integrations/constants";
import type { AzureIntegration } from "@p0security/shared/integrations/resources/azure/types";
import { WindowsComponents } from "@p0security/shared/integrations/resources/windows/components";
import { useFirestoreDoc } from "providers/FirestoreProvider";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { windowsInstaller } from "./install/install";

export const API_PATH = "integrations/windows/config";

export const Windows = (
  props: Pick<
    InstallProps<typeof WindowsComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "subscription", []);

  const azureDoc = useFirestoreDoc<AzureIntegration>("integrations/azure", {
    tenantAware: true,
  });

  return (
    <Install<typeof WindowsComponents>
      components={WindowsComponents}
      installer={windowsInstaller(azureDoc)}
      integration="windows"
      itemKind={itemKind}
      logo={WindowsIconUrl}
      title="Windows"
      {...props}
    />
  );
};
